import { useState } from "react";

import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";

import { getLabel } from "../../tools/Dictionary";

const VariableDesignerSensorBatch = (props) =>
{

  //Props
  const OnCloseModal = props.OnCloseModal;
  const OnConfirm = props.OnConfirm;

  //State
  const [value, setValue] = useState("");
  const [error, setError] = useState(undefined);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  const onChangeValue = (e) => {

    setValue(e.target.value);


  };

  const onClickConfirm = () => {


    const regex = /^-?\d+(\.\d+)?;-?\d+(\.\d+)?$/;
    const lines = value.trim().split('\n'); // Split the string into lines


    try{

      const result = lines.map((line, index) =>
      {

        let trimmedLine = line.trim().replace(/,/g, '.');



        if (!regex.test(trimmedLine))
        {
          throw new Error(` #${index + 1} : ${trimmedLine}`);
        }

        const [temperature, resistance] = trimmedLine.split(';'); // Split each line by ';'
        return { temperature, resistance }; // Create the object
      });

      
      setError("");
      OnConfirm(result);

    }catch(err){

      setError(err.message);

    }



  };

  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "400px" }}>
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("VariableDesigner", "Add in batch")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="variabledesigner_batch_title">
              {getLabel("VariableDesigner", "Values to add")}
            </div>
          </div>
          {error &&
            <div className="page_modal_body_row">
              <div className="variabledesigner_batch_data page_modal_body_col_error">
                {getLabel("VariableDesigner", "Error at line") + error}
                </div>
            </div>
          }
          <div className="page_modal_body_row">
            <div className="variabledesigner_batch_data" style={{ width: "300px" }} >
              <textarea
                className={"page_textarea_input " + (error ? "page_modal_body_col_input_error" : "")}
                rows={20}
                value={value|| ""}
                onChange={onChangeValue}
                type="text"
                style={{ width: "100%" }}
              />

            </div>
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(!OnCloseModal) ? undefined : OnCloseModal}
          />
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Confirm")}
            style={{ maxWidth: "200px" }}
            onClick={onClickConfirm}
            disabled={false}
          />
        </div>
      </div>
    </div>
  );

};

export default VariableDesignerSensorBatch